module.exports = __webpack_public_path__ + "static/media/like-icon-filled.a4ae55b4.svg";